module.exports = __webpack_public_path__ + "static/media/btn_android_ptb.db8ea79a.png";